import { GetStaticPaths, GetStaticProps } from 'next';

import ApiService from '@/lib/api';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import MainLayout from '../../layouts/MainLayout';
import { imageUrlBuilder } from '@/utils/helpers';
import { withSiteName } from '@/utils/pageTitle';

const ChaptersLayout = dynamic(() => import('@/components/Blog/ChaptersLayout'));
const NormalLayout = dynamic(() => import('@/components/Blog/NormalLayout'));

// import { groupTags } from '@/utils/helpers';

export const getStaticPaths: GetStaticPaths = async () => {
  const apiService = new ApiService();
  const postList = await apiService.getBlogPostsPath();

  return {
    paths: postList.map((route) => ({
      params: { slug: route.slug },
    })),
    fallback: true,
  };
};

export const getStaticProps: GetStaticProps = async ({ params: { slug }, preview = false }) => {
  const apiService = new ApiService();
  const postsPerPage = 3;
  const currentPage = 1;

  const data = preview
    ? await apiService.getBlogPostPreview(slug as string)
    : await apiService.getBlogPost(slug as string);
  if (!data) {
    return { notFound: true };
  }
  const [{ blogPost = null, footer }, menuData, relatedPosts] = await Promise.all([
    apiService.getMiscData(),
    apiService.getMenuData(),
    apiService.getRelatedBlogPosts({
      tag: null,
      id: data._id,
      from: currentPage,
      to: postsPerPage,
    }),
  ]);

  return {
    props: {
      post: data,
      relatedPosts,
      slug,
      footer,
      menuData,
      blogPostMeta: blogPost,
    },
    revalidate: 3600,
  };
};

const ProfilePage = ({ post, blogPostMeta, slug, menuData, footer, relatedPosts }) => {
  const ogUrl = `https://foxbox.com/blog/${slug}`;

  const imgSrc = post?.mainImage
    ? imageUrlBuilder.image(post.mainImage.image.asset).maxWidth(2048).auto('format').quality(80).url()
    : '';

  return (
    <>
      {imgSrc && (
        <Head>
          <link rel="preload" as="image" href={imgSrc} />
        </Head>
      )}
      <MainLayout
        bgWhite={!post?.useChaptersLayout}
        navIsFixed={false}
        navIsDark={!post?.useChaptersLayout}
        metaTitle={post?.metaTitle || withSiteName(post?.title)}
        metaDescription={post?.metaDescription}
        ogUrl={ogUrl}
        ogImage={imgSrc}
        footer={footer}
        menuData={menuData}
      >
        {post?.useChaptersLayout ? (
          <ChaptersLayout post={post} permalink={ogUrl} />
        ) : (
          <NormalLayout post={post} postList={relatedPosts} permalink={ogUrl} blogPostCopy={blogPostMeta} />
        )}
      </MainLayout>
    </>
  );
};

export default ProfilePage;
